import { AnyAction } from 'redux';

import * as A from './actions';
import { AGGridStateFactory } from './helpers';
import { AgGridStateRecord } from './types';

export const reducer = {
  agGrid(state: AgGridStateRecord = AGGridStateFactory(), action: AnyAction): AgGridStateRecord {
    switch (action.type) {
      case A.agGridRefreshServerSideAction.type:
        return state.set('refreshServerSide', action.payload);

      case A.agGridRefreshColumnDefsAction.type:
        return state.set('refreshColumnDefs', action.payload);

      default:
        return state;
    }
  },
};
